import React, { useCallback } from 'react';
import { Flex } from '@ui-library/misc';
import { useQueryBuilderState } from '../queryBuilderContext';
import classes from '../style.module.scss';
import FieldSelect from './fieldSelect';
import { FieldPropName, SelectedFields } from '../types';
import { GA_FIELD_PROPERTY } from '../constants';
import { startCase } from 'lodash';

interface ResourceSelectProps {
  onChange?: (resource: SelectedFields) => void;
  disabled?: boolean;
}

const FieldsSelection: React.FC<ResourceSelectProps> = ({ onChange, disabled }) => {
  const { loading, fields, selectedFields, resource } = useQueryBuilderState();
  const onChangeCL = useCallback(
    (type: FieldPropName) => (values: string[]) => {
      const newValues = { ...selectedFields, [type]: values };
      if (onChange) {
        onChange(newValues);
      }
    },
    [onChange, selectedFields],
  );
  const areFieldsDisabled = disabled || loading || !resource;
  return (
    <Flex className={classes.fieldsWrapper}>
      <FieldSelect
        className={classes.fieldItem}
        placeholder={startCase(GA_FIELD_PROPERTY.ATTRIBUTES)}
        options={fields[GA_FIELD_PROPERTY.ATTRIBUTES] || []}
        loading={loading}
        onChange={onChangeCL(GA_FIELD_PROPERTY.ATTRIBUTES)}
        disabled={areFieldsDisabled}
        value={selectedFields[GA_FIELD_PROPERTY.ATTRIBUTES]}
      />
      <FieldSelect
        className={classes.fieldItem}
        value={selectedFields[GA_FIELD_PROPERTY.SEGMENTS]}
        placeholder={startCase(GA_FIELD_PROPERTY.SEGMENTS)}
        options={fields.segments || []}
        loading={loading}
        onChange={onChangeCL(GA_FIELD_PROPERTY.SEGMENTS)}
        disabled={areFieldsDisabled}
      />
      <FieldSelect
        className={classes.fieldItem}
        placeholder={startCase(GA_FIELD_PROPERTY.METRICS)}
        options={fields.metrics || []}
        loading={loading}
        onChange={onChangeCL(GA_FIELD_PROPERTY.METRICS)}
        value={selectedFields[GA_FIELD_PROPERTY.METRICS]}
        disabled={areFieldsDisabled}
      />
    </Flex>
  );
};

export default FieldsSelection;
